import { Box, Button, FileUpload, Flex, Heading, Link, Separator, SimpleGrid, Text } from "@chakra-ui/react"
import { LuDownload, LuUpload, LuFileX } from "react-icons/lu";
import { useChatHistory } from "../chat-history";
import { ColorPickRow } from "./color-pick";
import { useAccount } from "./account-context";
import config from '../../config.json';
import { useAuth } from "./auth-context";

interface SettingsPageProps {
    fontFamily: string,
}



export const GeneralPage = (_props: SettingsPageProps) => {

    return (
        <Box w={'100%'} fontFamily={_props.fontFamily}>
            <Heading fontFamily={'inherit'} p={0} pb={'0.5rem'} size={'md'}>General Settings</Heading>
            <Flex direction="column" gap={4}>
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Language</Text>
                    <Text color="gray.500" fontSize="xs">Choose your preferred language for the interface (Coming soon).</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Theme Preference</Text>
                    <Text color="gray.500" fontSize="xs">Toggle between Light, Dark, and System theme (Coming soon).</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Compact Mode</Text>
                    <Text color="gray.500" fontSize="xs">Enable a denser layout for chat messages (Coming soon).</Text>
                </Box>
            </Flex>
        </Box>
    )
}
// export const InterfacePage = (_props: SettingsPageProps) => {
//     return (
//         <Box fontFamily={_props.fontFamily} w={'100%'}>
//             <Heading fontFamily={'inherit'} pb={'0.5rem'} size={'md'}>UI</Heading>
//         </Box>
//     )
// }
// export const PersonalizationPage = (_props: SettingsPageProps) => {
//     return (
//         <Box fontFamily={_props.fontFamily} w={'100%'}>
//             {/* <Heading fontFamily={'inherit'} pb={'0.5rem'} size={'md'}>Personalization</Heading> */}
//             <Heading fontFamily={'inherit'} p={0} pb={'0.5rem'} size={'md'}>Color Profile / Theme</Heading>
//             <SimpleGrid columns={3} >
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text pr={'8px'} fontWeight={'bold'}>50</Text>
//                     <ColorPickRow colorKey="50" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text pr={'3px'} fontWeight={'bold'}>100</Text>
//                     <ColorPickRow colorKey="100" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>200</Text>
//                     <ColorPickRow colorKey="200" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>300</Text>
//                     <ColorPickRow colorKey="300" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>400 </Text>
//                     <ColorPickRow colorKey="400" disabled />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>500</Text>
//                     <ColorPickRow colorKey="500" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>600</Text>
//                     <ColorPickRow colorKey="600" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>700</Text>
//                     <ColorPickRow colorKey="700" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>800</Text>
//                     <ColorPickRow colorKey="800" />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>900</Text>
//                     <ColorPickRow colorKey="900" disabled />
//                 </Flex>
//                 <Flex gap={2} alignItems={'center'} mb={4}>
//                     <Text fontWeight={'bold'}>950 </Text>
//                     <ColorPickRow colorKey="950" disabled />
//                 </Flex>
//             </SimpleGrid>
//         </Box>
//     )
// }

// export const AudioPage = (_props: SettingsPageProps) => {
//     return (
//         <Box>Audio</Box>
//     )
// }
export const ChatsPage = (_props: SettingsPageProps) => {

    const {
        deleteAllSessions,
        downloadHistory,
        importHistory
    } = useChatHistory();


    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            importHistory(file);
            event.target.value = '';
        }
    };

    return (
        <Box w={'100%'} fontFamily={_props.fontFamily}>
            <Heading fontFamily={'inherit'} p={0} pb={'0.5rem'} size={'md'}>Chat Settings</Heading>
            <Flex direction="column" gap={4}>
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Auto-delete History</Text>
                    <Text color="gray.500" fontSize="xs">Automatically delete conversations older than 30 days (Coming soon).</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Search History</Text>
                    <Text color="gray.500" fontSize="xs">Search through your past conversations (Coming soon).</Text>
                </Box>
                <Separator />
                <Box>
                    <Flex justify="space-between" align="center">
                        <Box>
                            <Text fontWeight="semibold" fontSize="sm">Import History</Text>
                            <Text color="gray.500" fontSize="xs">Upload a JSON file to restore your chat history.</Text>
                        </Box>
                        <Box>
                        <FileUpload.Root onChange={handleFileChange} >
                            <FileUpload.HiddenInput />
                            <FileUpload.Trigger asChild >
                                <Button variant="outline" size="sm">
                                    <LuUpload /> Import
                                </Button>
                            </FileUpload.Trigger>
                        </FileUpload.Root>
                        </Box>
                    </Flex>
                </Box>
                <Separator />
                <Box>
                    <Flex justify="space-between" align="center">
                        <Box>
                            <Text fontWeight="semibold" fontSize="sm">Export History</Text>
                            <Text color="gray.500" fontSize="xs">Download your entire chat history as a JSON file.</Text>
                        </Box>
                        <Button onClick={() => { downloadHistory() }} variant="outline" size="sm"><LuDownload /> Export</Button>
                    </Flex>
                </Box>
                <Separator />
                <Box>
                    <Flex justify="space-between" align="center">
                        <Box>
                            <Text fontWeight="semibold" fontSize="sm">Delete All History</Text>
                            <Text color="gray.500" fontSize="xs">Permanently remove all conversations from your account.</Text>
                        </Box>
                        <Button onClick={deleteAllSessions} colorPalette={'red'} variant="subtle" size="sm"><LuFileX /> Delete All</Button>
                    </Flex>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Privacy & Data</Text>
                    <Text color="gray.500" fontSize="xs">Your conversations are stored securely and are not used for model training without your explicit consent.</Text>
                </Box>
            </Flex>
        </Box>
    )
}

export const AccountPage = (_props: SettingsPageProps) => {
    const { accountType } = useAccount();
    const { user } = useAuth();
    
    const name = user ? user.name : "Unknown User";
    const email = user ? user.email : "N/A";
    const organization = user ? user.OU : "N/A";

    return (
        <Box w={'100%'} fontFamily={_props.fontFamily}>
            <Heading fontFamily={'inherit'} p={0} pb={'0.5rem'} size={'md'}>Account Settings</Heading>
            <Flex direction="column" gap={4}>
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Profile Information</Text>
                    <Text color="gray.500" fontSize="xs">{name}</Text>
                    <Text color="gray.500" fontSize="xs">{email}</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Organization</Text>
                    <Text color="gray.500" fontSize="xs">{organization}</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Account Type</Text>
                    <Text color="gray.500" fontSize="xs">{accountType === 'admin' ? 'Administrator' : 'Standard User'}</Text>
                </Box>
                <Separator />
                {/* <Box>
                    <Text fontWeight="bold" fontSize="sm">Security</Text>
                    <Text color="gray.500" fontSize="xs">Manage passwords and multi-factor authentication (Coming soon).</Text>
                </Box> */}
                {/* <Separator />
                <Box>
                    <Text fontWeight="bold" fontSize="sm">Active Sessions</Text>
                    <Text color="gray.500" fontSize="xs">View and manage where you're currently logged in (Coming soon).</Text>
                </Box> */}
            </Flex>
        </Box>
    )
}

export const AboutPage = (_props: SettingsPageProps) => {
    return (
        <Box w={'100%'} fontFamily={_props.fontFamily}>
            <Heading fontFamily={'inherit'} p={0} pb={'0.5rem'} size={'md'}>About & Support</Heading>
            <Flex direction="column" gap={4}>
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Software Information</Text>
                    <Text color="gray.500" fontSize="xs">Version: {config.version}</Text>
                    <Text color="gray.500" fontSize="xs">Build: {config.build}</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Resources</Text>
                    <Link pt={"0.25rem"} display="block" colorPalette={'blue'} variant={"underline"} fontSize="xs" href="/dol-worker-ai-assist/patch-notes.md">Patch Notes</Link>
                    <Text color="gray.500" fontSize="xs" mt={1}>Check out what's new in the latest update.</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Legal & Privacy</Text>
                    <Text color="gray.500" fontSize="xs">Terms of Service and Privacy Policy (Coming soon).</Text>
                </Box>
                <Separator />
                <Box>
                    <Text fontWeight="semibold" fontSize="sm">Support</Text>
                    <Text color="gray.500" fontSize="xs">Need help? Contact our support team (Coming soon).</Text>
                </Box>
            </Flex>
        </Box>
    )
}
